import { useState } from "react";
import { Table, Button, Modal } from "flowbite-react";
import "./acceptProposal.css";
import { AcceptTrocProposal } from "../../../../services/callAPI/trocsPropositions";
import UnvalidToast from "../../../toasts/UnvalidToast";
import ValidToast from "../../../toasts/ValidToast";
import { getExchangeElementOfRes } from "../../../../services/callAPI/toResidentsTrocs";

interface IAcceptProposal {
  travTrocId: number;
  resTrocId: number;
  setTrigUseEffect: React.Dispatch<React.SetStateAction<boolean>>;
}

function AcceptProposal(props: IAcceptProposal) {
  //destructuring
  const { travTrocId, resTrocId, setTrigUseEffect } = props;

  const [openModal, setOpenModal] = useState(false);
  const [openToastUnvalid, setopenToastUnvalid] = useState<boolean>(false);
  const [openToastValid, setopenToastValid] = useState<boolean>(false);
  const [errorMsg, seterrorMsg] = useState<string | undefined>(undefined);
  const [exchangeElementOfRes, setexchangeElementOfRes] = useState<{
    id: number;
    title: string;
    services: [string | null, string | null, string | null];
    needs: [string | null, string | null, string | null];
  }>()

  async function handleClickAccept() {
    try {
      //call api
      const exchangeElementData = await getExchangeElementOfRes(resTrocId);

      setexchangeElementOfRes(exchangeElementData);

      setOpenModal(true); //open modal
    } catch (error) {
      if (error instanceof Error) {
        seterrorMsg(error.message);
      }
      setopenToastUnvalid(true); //show toast unvalid
    }
  }

  async function handleClickYes() {
    try {
      if (await AcceptTrocProposal(travTrocId, resTrocId) != 204) {
        throw new Error(`status is diferent of 204`);
      }

      setopenToastValid(true);//show validToast      

      const timer = setTimeout(() => {
        setTrigUseEffect(prev => !prev);
      }, 4000);

      //clean timer
      return () => clearTimeout(timer);

    } catch (error) {
      if (error instanceof Error) {
        seterrorMsg(error.message);//add error msg

        setopenToastUnvalid(true); //show unvalidToast

        setTimeout(() => {
          setTrigUseEffect(prev => !prev);
        }, 3000);
      }
      else {
        setTimeout(() => {
          setTrigUseEffect(prev => !prev);
        }, 3000);
      }
    }
    finally {
      setOpenModal(false); //close modal
    }
  }

  return (
    <>
      {openToastUnvalid &&
        <UnvalidToast
          onClose={() => {
            setopenToastUnvalid(false);
            seterrorMsg(undefined)
          }}
          message={errorMsg}
        />
      }
      {openToastValid && <ValidToast onClose={() => setopenToastValid(false)} />}

      <Button
        id="btn-accept-proposal"
        onClick={() => handleClickAccept()}
        className="bg-greenCustom w-1/2 max-w-28"
      >
        Accepter
      </Button>

      <Modal
        show={openModal}
        size="md"
        onClose={() => setOpenModal(false)}
        popup
        className="bg-transparent backdrop-blur-sm"
      >
        <div className="modal-exchange-item flex flex-col justify-center items-center">
          <Modal.Header>
            <p className="text-center">Ci-dessous mon élément à échanger</p>
          </Modal.Header>

          <Modal.Body className="p-0">
            <div className="flex flex-col gap-2 text-center">
              {/* table */}
              <div className="overflow-x-auto">
                <Table>

                  <Table.Head>
                    <Table.HeadCell className="text-center">{exchangeElementOfRes?.title}</Table.HeadCell>
                  </Table.Head>

                  <Table.Body className="divide-y">
                    <Table.Row className="bg-white dark:border-gray-700 dark:bg-gray-800">
                      <Table.Cell className="t-cell-no-padding text-center whitespace-nowrap font-medium text-gray-900 dark:text-white">
                        <div>Mes services</div>
                        {/* images services */}
                        <div id="res-services-list" className="flex flex-wrap justify-center gap-3">

                          {exchangeElementOfRes?.services[0] && (
                            <img className="h-20 w-20" src={`${"/besoinsDuNomade-servicesDuRésident/" + exchangeElementOfRes?.services[0] + ".png"}`} alt="Service1" />
                          )}

                          {exchangeElementOfRes?.services[1] && (
                            <img className="h-20 w-20" src={`${"/besoinsDuNomade-servicesDuRésident/" + exchangeElementOfRes?.services[1] + ".png"}`} alt="Service2" />
                          )}

                          {exchangeElementOfRes?.services[2] && (
                            <img className="h-20 w-20" src={`${"/besoinsDuNomade-servicesDuRésident/" + exchangeElementOfRes?.services[2] + ".png"}`} alt="Service3" />
                          )}

                        </div>
                      </Table.Cell>
                    </Table.Row>

                    <Table.Row className="bg-white dark:border-gray-700 dark:bg-gray-800">
                      <Table.Cell className="t-cell-no-padding text-center whitespace-nowrap font-medium text-gray-900 dark:text-white">
                        <div>Mes besoins</div>
                        {/* images needs */}
                        <div id="res-needs-list" className="flex flex-wrap justify-center gap-3">

                          {exchangeElementOfRes?.needs[0] && (
                            <img className="h-20 w-20" src={`${"/servicesDuNomade-besoinsDuRésident/" + exchangeElementOfRes?.needs[0] + ".png"}`} alt="Service1" />
                          )}

                          {exchangeElementOfRes?.needs[1] && (
                            <img className="h-20 w-20" src={`${"/servicesDuNomade-besoinsDuRésident/" + exchangeElementOfRes?.needs[1] + ".png"}`} alt="Service2" />
                          )}

                          {exchangeElementOfRes?.needs[2] && (
                            <img className="h-20 w-20" src={`${"/servicesDuNomade-besoinsDuRésident/" + exchangeElementOfRes?.needs[2] + ".png"}`} alt="Service3" />
                          )}

                        </div>
                      </Table.Cell>
                    </Table.Row>
                  </Table.Body>

                </Table>
              </div>

              {/* actions confirm or not */}
              <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
                Je confirme l'acceptation de ce troc
              </h3>

              <div className="pb-2 flex justify-center gap-4">
                <Button className="bg-greenCustom" onClick={() => handleClickYes()}>
                  {"Oui, je suis sûr"}
                </Button>
                <Button className="bg-lightRedCustom" onClick={() => setOpenModal(false)}>
                  Non, pas sûr
                </Button>
              </div>
            </div>
          </Modal.Body>

        </div>
      </Modal>
    </>
  )
}
export default AcceptProposal;